export function LiveGameAgeIndicator({ currentAge, canAgeUp }) {
	return (
		<div>
			<div className="liveGameOverlay__ageUpIndicator h-[92px] mt-4 relative -ml-8">
				<img
					className="liveGameOverlay__ageUpBackground w-[62px] h-[62px] rounded-full top-0 left-0 relative border-yellow-400 border-2"
					src="/liveGameIcons/age_background.png"
				/>
				<img
					className="w-[52px] absolute top-[12px] left-[0.33rem]"
					src={`/liveGameIcons/age_${currentAge}${canAgeUp ? '_ready' : ''}.png`}
				/>
			</div>
		</div>
	)
}
